// src/i18n.js

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const syncHtmlLang = lng => {
  if (typeof document === 'undefined') return;
  const normalized = String(lng || '').toLowerCase();
  document.documentElement.lang = normalized.startsWith('zh') ? 'zh-CN' : 'en';
};

// 配置 i18next
i18n
  .use(HttpBackend) // 通过HTTP加载语言文件
  .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 使react-i18next生效
  .init({
    fallbackLng: 'en', // 默认语言
    debug: true, // 开启调试
    interpolation: {
      escapeValue: false, // React已处理过XSS，故不需要转义
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // 语言文件的路径
    },
  });

syncHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
